<template>
  <div class="detail">
    <myDialog :logTitle="'路救基金申请明细'" :showDialog.sync="open">
      <el-button type="primary" class="close" icon="el-icon-circle-close" size="medium" @click="close"/>
      <div class="main-content" v-if="isLoaded">
        <Descriptions title="事故基本信息" col="8">
          <description-item label="案件号">{{ applyRecord.caseId }}</description-item>
          <description-item label="垫付类型">{{
              dictMap.road_rescue_apply_fee_type[applyRecord.applyFeeType]
            }}
          </description-item>
          <description-item label="事故时间">{{ applyRecord.sgTime }}</description-item>
          <description-item label="事故详细地址">{{ applyRecord.sgAddress }}</description-item>
        </Descriptions>
        <Descriptions title="交警部门提供材料" col="12">
          <description-item type="link" label="救助基金申请垫付通知书"
                            :href="fileMap['40020088110'] ? fileMap['40020088110'].filePath : ''">
            {{ fileMap['40020088110'] ? fileMap['40020088110'].fileName : '' }}
          </description-item>
          <description-item type="link" label="交强险垫付通知书"
                            :href="fileMap['40020088120'] ? fileMap['40020088120'].filePath : ''">
            {{ fileMap['40020088120'] ? fileMap['40020088120'].fileName : '' }}
          </description-item>
        </Descriptions>
        <Descriptions title="受害人信息" col="8" :content="applyRecord">
          <description-item label="姓名">{{ applyRecord.shrName }}</description-item>
          <description-item label="证件类型">
            {{ dictMap.road_rescue_shr_credentials_type[applyRecord.shrCredentialsType] }}
          </description-item>
          <description-item label="证件号">{{ applyRecord.shrCredentialsCode }}</description-item>
          <description-item label="联系方式">{{ applyRecord.shrPhone }}</description-item>
          <description-item label="证件地址">{{ applyRecord.identityCardAddress }}</description-item>
          <description-item label="现居住地址">{{ applyRecord.currentResidenceAddress }}</description-item>
        </Descriptions>
        <Descriptions title="申请人信息" col="8" :content="applyRecord">
          <description-item label="姓名">{{ applyRecord.sqjbrName }}</description-item>
          <description-item label="证件类型">
            {{ dictMap.road_rescue_sqjbr_credentials_type[applyRecord.sqjbrCredentialsType] }}
          </description-item>
          <description-item label="证件号">{{ applyRecord.sqjbrCredentialsCode }}</description-item>
          <description-item label="联系方式">{{ applyRecord.sqjbrPhone }}</description-item>
          <description-item label="与受害人关系">
            {{ dictMap.road_rescue_shr_relationship_type[applyRecord.shrRelationshipType] }}
          </description-item>
          <description-item label="医院申请填写亲属联系方式">{{ applyRecord.relativesPhone }}</description-item>
        </Descriptions>
        <Descriptions title="申请人材料" col="12">
          <description-item type="link" label="受害人身份证明"
                            :href="fileMap['40020088210'] ? fileMap['40020088210'].filePath : ''">
            {{ fileMap['40020088210'] ? fileMap['40020088210'].fileName : '' }}
          </description-item>
          <description-item type="link" label="申请人身份证明"
                            :href="fileMap['40020088220'] ? fileMap['40020088220'].filePath : ''">
            {{ fileMap['40020088220'] ? fileMap['40020088220'].fileName : '' }}
          </description-item>
        </Descriptions>
        <Descriptions v-if="applyRecord.applyFeeType === '2010001'" title="抢救费信息" col="24">
          <description-item type="text" label="医疗机构">{{ applyRecord.entName }}</description-item>
        </Descriptions>
        <Descriptions v-else-if="applyRecord.applyFeeType === '2010002'" title="丧葬费信息" col="24">
          <description-item type="text" label="丧葬机构">{{ applyRecord.entName }}</description-item>
        </Descriptions>
        <Descriptions title="医院机构材料" v-if="applyRecord.applyFeeType === '2010001'" col="8">
          <description-item type="link" label="入院记录/出院记录/诊断证明"
                            :href="fileMap['40020088310'] ? fileMap['40020088310'].filePath : ''">
            {{ fileMap['40020088310'] ? fileMap['40020088310'].fileName : '' }}
          </description-item>
          <description-item type="link" label="抢救费用未结算证明"
                            :href="fileMap['40020088320'] ? fileMap['40020088320'].filePath : ''">
            {{ fileMap['40020088320'] ? fileMap['40020088320'].fileName : '' }}
          </description-item>
          <description-item type="link" label="抢救费用清单"
                            :href="fileMap['40020088330'] ? fileMap['40020088330'].filePath : ''">
            {{ fileMap['40020088330'] ? fileMap['40020088330'].fileName : '' }}
          </description-item>
        </Descriptions>
        <Descriptions title="殡葬机构材料" v-if="applyRecord.applyFeeType === '2010002'" col="12">
          <description-item type="link" label="费用请单"
                            :href="fileMap['40020099310'] ? fileMap['40020099310'].filePath : ''">
            {{ fileMap['40020099310'] ? fileMap['40020099310'].fileName : '' }}
          </description-item>
          <description-item type="link" label="火化通知书"
                            :href="fileMap['40020099320'] ? fileMap['40020099320'].filePath : ''">
            {{ fileMap['40020099320'] ? fileMap['40020099320'].fileName : '' }}
          </description-item>
        </Descriptions>
      </div>
    </myDialog>
  </div>
</template>

<script>
import myDialog from '@/components/custom/myDialog.vue'
import Descriptions from "@/components/Description/Descriptions";
import {getApplyRecord} from "@/api/rescue/roadRescue";

export default {
  name: 'RoadRescueFundDetail',
  components: {myDialog, Descriptions},
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    dictMap: {
      type: Object,
      default: () => {
      }
    },
    caseId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoaded: false,
      applyRecord: {
        caseId: '',
        applyFeeType: '',
        sgTime: '',
        sgProv: '',
        sgCity: '',
        sgArea: '',
        sgAddress: '',
        shrName: '',
        shrPhone: '',
        shrCredentialsType: '',
        shrCredentialsCode: '',
        identityCardAddress: '',
        currentResidenceAddress: '',
        sqjbrName: '',
        sqjbrPhone: '',
        sqjbrCredentialsType: '',
        sqjbrCredentialsCode: '',
        shrRelationshipType: '',
        relativesPhone: '',
        isPeople: '',
        entName: '',
        channelType: '',
        fileList: [{
          fileId: '',
          fileName: '',
          filePath: '',
          fileTypeId: '',
        }]
      },
      fileMap: {},
    }
  },
  created() {
    this.init();
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
    init() {
      getApplyRecord(this.caseId).then(resp => {
          this.applyRecord = resp.data;
          this.fileMap = this.fileMapInit(resp.data.fileList);
          this.isLoaded = true;
        }
      );
    },
    fileMapInit(fileList) {
      let map = {};
      fileList.forEach(data => {
          map[data.fileTypeId] = data
        }
      )
      return map;
    }
  }
}
</script>

<style lang="scss">
.detail {
  width: 100%;

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #0F1F46;
  }

  .close:hover {
    background-color: #0F1F46;
  }

  .logContent {
    width: 80%;
  }

  .main-content {
    color: rgb(177, 227, 255);
    padding-left: 10px;
    padding-right: 10px;

    .title {
      font-size: 20px;
    }
  }
}

</style>>
